export default {
  computed: {
    imageSrc: function () {
      return function (url, width, height) {
        if (url) {
          return url
        } else {
          return `http://placehold.jp/eeeeee/cccccc/${width}x${height}.png?text=No%20Image`
        }
      }
    },
    productImageSrc: function () {
      return function (productImage, width, height) {
        if (productImage.imageType === 'file' && productImage.file.url) {
          return productImage.file.url
        } else if (productImage.imageType === 'url' && productImage.url) {
          return productImage.url
        } else {
          return `http://placehold.jp/eeeeee/cccccc/${width}x${height}.png?text=No%20Image`
        }
      }
    }
  },
  methods: {
    multipleProductImageUrl (image) {
      if (image.type === 'download_image_id') {
        return image.downloadImageUrl
      } else {
        return image.value
      }
    },
    getFilePath (filePath) {
      if (process.env.NODE_ENV === 'development' && filePath) {
        const protocol = window.location.protocol
        const hostName = window.location.hostname
        return `${protocol}//${hostName}${filePath}`
      } else if (filePath) {
        return filePath
      } else {
        return 'http://placehold.jp/eeeeee/cccccc/200x200.png?text=No%20Image'
      }
    }
  }
}
